import { render, staticRenderFns } from "./Nomenclature.vue?vue&type=template&id=2974b785&scoped=true"
import script from "./Nomenclature.vue?vue&type=script&lang=ts"
export * from "./Nomenclature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974b785",
  null
  
)

export default component.exports